import React from 'react';
import { Card } from '@amzn/stencil-react-components/card';
import { Col } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import { Spacer } from '@amzn/stencil-react-components/layout';
import { useGlobalContext } from 'src/hooks';
import { QualityEvent } from '../../types/backendService';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface QualityEventCardsProps {
  qualityEvents: QualityEvent[]
}

export const QualityEventCards = (props: QualityEventCardsProps) => {
  const { t } = useTranslation();
  const { userDetails } = useGlobalContext();

  return (
    <Col gridGap="S300" >
      {props.qualityEvents.map((qualityEvent: QualityEvent, index: number) => {
        const qualityEventTime = moment(qualityEvent.metricTime! * 1000);
        return (
          <Card data-cy="quality-event-card" key={index}>
            <Col width="100%">
              <Text fontSize="T400">{qualityEvent.errorType}</Text>
              <Text fontWeight="light">
                <em>
                  {t('eventOccurredAtDescription', {
                    time: qualityEventTime.tz(userDetails.locale).format(`hh:mm A [(${userDetails.locale})]`),
                    date: qualityEventTime.tz(userDetails.locale).format("M/D/Y"),
                    interpolation: {'escapeValue': false},
                  })}
                  </em>
              </Text>
              <Spacer height={16}/>
              {(qualityEvent.errorInfo!["Location Id"] != undefined) &&
                <Text>{t('locationId')}: {qualityEvent.errorInfo!["Location Id"]}</Text>
              }
              {(qualityEvent.errorInfo!["Application Name"] != undefined) &&
                <Text>{t('applicationName')}: {qualityEvent.errorInfo!["Application Name"]}</Text>
              }
              {(qualityEvent.errorInfo!["Reported In Process Path"] != undefined) &&
                <Text>{t('reportedInProcessPath')}: {qualityEvent.errorInfo!["Reported In Process Path"]}</Text>
              }
            </Col>
          </Card>
        );
      })}
    </Col>
  );
}
